import { getLatestDeploymentString } from '../scripts/deployment'

export const newDeployment = {
  data: () => ({
    __latestDeployment: null
  }),

  watch: {
    $route: {
      async handler() {
        const str = await getLatestDeploymentString()
        if (str !== this.__latestDeployment) this.__showRefreshWarning()
      },
      deep: true
    }
  },

  mounted() {
    this.__latestDeployment = document.querySelector('body').getAttribute('latest-deployment')
  },

  methods: {
    __showRefreshWarning() {
      this.$q.notify({
        icon: 'announcement',
        textColor: 'white',
        color: 'primary',
        multiLine: true,
        timeout: 8000,
        position: 'bottom-right',
        message: 'A new version of Roam is out!',
        caption: "Please save any changes you're making, and then refresh the page to get the latest version.",
        actions: [
          { label: 'Dismiss', color: 'white' },
          { label: 'Refresh now', color: 'yellow', handler: () => this.$router.go() }
        ]
      })
    }
  }
}
